import type { EmbeddedCheckoutCloseReason } from './panels/embedded-checkout-dialog-lit.js';

type PreparationState =
  | { status: 'idle' | 'preparing'; id?: number }
  | { status: 'closed'; id?: number; reason: EmbeddedCheckoutCloseReason };

/** Keep close ownership when the dialog closes before its async preparation ends. */
export class CheckoutPreparation {
  private state: PreparationState = { status: 'idle' };
  private closed: (() => void) | undefined;
  get id(): number | undefined { return this.state.id; }
  get closeReason(): EmbeddedCheckoutCloseReason | null { return this.state.status === 'closed' ? this.state.reason : null; }

  prepare(start: (close: (reason: EmbeddedCheckoutCloseReason) => void) => number | undefined): number | undefined {
    if (this.state.status !== 'idle') return this.state.id;
    this.state = { status: 'preparing' };
    const id = start(reason => this.close(reason));
    this.state = { ...this.state, id };
    return id;
  }

  watchClose(callback: () => void): void {
    this.closed = callback;
    if (this.state.status === 'closed') callback();
  }

  close(reason: EmbeddedCheckoutCloseReason): void {
    if (this.state.status === 'closed') return;
    this.state = { status: 'closed', id: this.state.id, reason };
    this.closed?.();
  }
}
